import moment from 'moment';
import { $ } from '../simpli';
export function toString(val) {
    return val !== null && val !== undefined ? String(val) : '';
}
export function bool(val) {
    return val !== undefined && val !== null ? $.t("boolean." + val) : '';
}
export function datetime(date) {
    return date && moment(date).isValid() ? moment(date).format($.t('dateFormat.datetime')) : '';
}
export function date(date) {
    return date && moment(date).isValid() ? moment(date).format($.t('dateFormat.date')) : '';
}
export function time(date) {
    return date && moment(date).isValid() ? moment(date).format($.t('dateFormat.time')) : '';
}
export function truncate(val, length) {
    return $.filter.truncate(val, length);
}
export function stripHtml(val) {
    return $.filter.stripHtml(val);
}
export function removeDelimiters(val) {
    return $.filter.removeDelimiters(val);
}
export function phone(val) {
    return $.filter.phone(val);
}
export function zipcode(val) {
    return $.filter.zipcode(val);
}
export function rg(val) {
    return $.filter.rg(val);
}
export function cpf(val) {
    return $.filter.cpf(val);
}
export function cnpj(val) {
    return $.filter.cnpj(val);
}
export function cpfOrCnpj(val) {
    return $.filter.cpfOrCnpj(val);
}
export function pad(val, length) {
    return $.filter.pad(val, length);
}
//# sourceMappingURL=filter.helper.js.map